export default {
  opportunityDefinitionsAsOptions(state) {
    return Object.keys(state.definitions).map((opportunitySfid) => {
      return state.definitions[opportunitySfid];
    });
  },
};
